import { render, staticRenderFns } from "./TrackerEdit.vue?vue&type=template&id=2c412bf8&scoped=true&"
import script from "./TrackerEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c412bf8",
  null
  
)

export default component.exports